<article class="lum-c-sales-order-form">
  <form [formGroup]="form" (submit)="onSubmit($event)">
    <header mat-dialog-title class="lum-c-sales-order-form__head">
      <h3>{{ title }}</h3>
      <button
        mat-dialog-close
        aria-label="Close 'Create Sales Order' Dialog"
        class="close lum-c-sales-order-form__close"
      >
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div mat-dialog-content class="lum-c-sales-order-form__body">
      <div class="lum-c-sales-order-form__body-section  row">
        <div class="col-lg-3">
          <label class="form-group">
            <div class="lum-label">Order Number</div>
            <input
              type="text"
              class="lum-input"
              matInput
              formControlName="orderNumber"
              [placeholder]="placeholderOrderNumber"
            />
          </label>
        </div>
        <div class="col-lg-3">
          <label class="form-group">
            <div class="lum-label">Custom PO Number</div>
            <input
              type="text"
              class="lum-input"
              matInput
              formControlName="customerPoNumber"
            />
          </label>
        </div>
        <div class="col-lg-2">
          <label class="form-group">
            <div class="lum-label">Order Date</div>
            <lum-ui-datepicker
              [formControl]="orderDateFormControl"
              [placeholder]="'Select order date'"
            ></lum-ui-datepicker>
          </label>
        </div>
        <div class="col-lg-2">
          <label class="form-group">
            <div class="lum-label">Ship By Date</div>
            <lum-ui-datepicker
              [formControl]="requestedShipDateFormControl"
              [placeholder]="'Select ship by date'"
            ></lum-ui-datepicker>
          </label>
        </div>
        <div class="col-lg-2">
          <label class="form-group">
            <div class="lum-label">Earliest Ship Date</div>
            <lum-ui-datepicker
              [formControl]="doNotShipBeforeFormControl"
              [placeholder]="'Earliest ship date'"
            ></lum-ui-datepicker>
          </label>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="lum-c-sales-order-form__body-section  row">
        <div class="col-12 col-lg-10 d-flex gap-2">
          <label class="form-group grow">
            <div class="lum-label">Company</div>
            <lum-company-autocomplete
              formControlName="company"
            ></lum-company-autocomplete>
          </label>

          <em
            *ngIf="!currentCompany"
            class="lum-form__item--emulate-label mx-2 pt-3 text-cloud-500"
            >- OR -</em
          >

          <lum-client-profile-create
            class="lum-form__item--emulate-label"
            [client]="currentCompany ?? null"
          ></lum-client-profile-create>
          <div>
            <button
              *ngIf="currentCompany"
              type="button"
              class="lum-button lum-button--link lum-form__item--emulate-label"
              (click)="handleAddPayMethod($event)"
            >
              <lum-ui-icon
                icon="money-atm-card"
                width="19"
                height="19"
              ></lum-ui-icon>
              Add Pay Profile
            </button>
          </div>
        </div>
      </div>
      <div class="lum-c-sales-order-form__body-section  row">
        <div class="col-lg-3">
          <label class="form-group">
            <div class="lum-label">Email</div>
            <input
              type="email"
              class="lum-input"
              matInput
              formControlName="email"
            />
          </label>
        </div>
        <div class="col-lg-3">
          <label class="form-group">
            <div class="lum-label">Phone</div>
            <input type="text" class="lum-input" matInput formControlName="phone" />
          </label>
        </div>
        <div class="col-lg-3">
          <label class="form-group">
            <div class="lum-label">Name</div>
            <input type="text" class="lum-input" matInput formControlName="name" />
          </label>
        </div>
      </div>

      <div class="lum-c-sales-order-form__shipping-address-section">
        <div class="lum-c-sales-order-form__body-section row align-items-center">
          <div class="col-12 d-flex align-items-center gap-3">
            <h5 class="mb-0">Ship To</h5>
            <div
              *ngIf="currentSalesOrder?.isShippingAddressOverridden"
              class="
                py-1 px-2 mb-0 text-warning d-flex align-items-center gap-1 bg-warning bg-opacity-25 rounded
              "
              role="alert"
              style="font-size: 0.95em; display: inline-block"
            >
              <i
                class="fas fa-exclamation-triangle text-warning me-1"
                style="font-size: 1.1em"
              ></i>
              The shipping address for this order has been manually overridden and
              may differ from the original address.
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="lum-c-sales-order-form__body-section  row">
          <div class="col-lg-4">
            <div class="form-group">
              <label class="lum-label">Shipping Address</label>
              <lum-client-shipping-address-accessor
                formControlName="shippingAddressId"
                [businessAccountId]="form.get('company')?.value?.id"
                (selectedAddressEvent)="onSelectShippingAddresss($event)"
                [isUpdateMode]="!!data?.salesOrderId"
              ></lum-client-shipping-address-accessor>
            </div>
          </div>
          <div
            *ngIf="
              'utah-UTAH-338-expose_requested_shipping_service_field' | featureFlag
            "
            class="col-lg-4 offset-lg-4"
          >
            <label class="form-group">
              <div class="lum-label">Requested Shipping Service</div>
              <input
                type="text"
                class="lum-input"
                matInput
                formControlName="requestedShippingService"
                placeholder="Enter shipping service"
              />
            </label>
          </div>
        </div>
        <div class="lum-c-sales-order-form__body-section  row">
          <div class="col-lg-4">
            <label class="form-group">
              <div class="lum-label">Shipping Address Line 1</div>
              <input
                type="text"
                class="lum-input"
                matInput
                formControlName="street1"
                [ngClass]="{
                  error: form?.get('street1')?.invalid,
                }"
              />
            </label>
          </div>
          <div class="col-lg-4">
            <label class="form-group">
              <div class="lum-label">Shipping Address Line 2</div>
              <input
                type="text"
                class="lum-input"
                matInput
                formControlName="street2"
              />
            </label>
          </div>
          <div class="col-lg-4">
            <label class="form-group">
              <div class="lum-label">Shipping Address Line 3</div>
              <input
                type="text"
                class="lum-input"
                matInput
                formControlName="street3"
              />
            </label>
          </div>
        </div>

        <div class="lum-c-sales-order-form__body-section  row">
          <div class="col-lg-3">
            <label class="form-group">
              <div class="lum-label">City</div>
              <input
                type="text"
                class="lum-input"
                matInput
                formControlName="city"
                [ngClass]="{
                  error: form?.get('city')?.invalid,
                }"
              />
            </label>
          </div>
          <div class="col-lg-3">
            <label class="form-group">
              <div class="lum-label">State</div>
              <input
                type="text"
                class="lum-input"
                matInput
                formControlName="state"
                [ngClass]="{
                  error: form?.get('state')?.invalid,
                }"
              />
            </label>
          </div>
          <div class="col-lg-3">
            <label class="form-group">
              <div class="lum-label">ZIP/Postal Code</div>
              <input
                type="text"
                class="lum-input"
                matInput
                formControlName="postalCode"
                [ngClass]="{
                  error: form?.get('postalCode')?.invalid,
                }"
              />
            </label>
          </div>
          <div class="col-lg-3">
            <label class="form-group">
              <div class="lum-label">Country</div>
              <lum-country-autocomplete
                [formControl]="countryFormControl"
              ></lum-country-autocomplete>
            </label>
          </div>
        </div>
      </div>

      <div
        class="lum-c-sales-order-form__bill-to-address-section"
        formGroupName="billTo"
      >
        <div class="lum-c-sales-order-form__body-section row">
          <div class="col-12">
            <h5>Bill To</h5>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="lum-c-sales-order-form__body-section">
          <div class="row">
            <div class="col-lg-6">
              <label class="form-group">
                <div class="lum-label">Name</div>
                <input
                  type="text"
                  class="lum-input"
                  matInput
                  formControlName="name"
                  [ngClass]="{
                    error: form?.get('billTo.name')?.invalid,
                  }"
                />
              </label>
            </div>
            <div class="col-lg-6">
              <label class="form-group">
                <div class="lum-label">Company</div>
                <input
                  type="text"
                  class="lum-input"
                  matInput
                  formControlName="company"
                  [ngClass]="{
                    error: form?.get('billTo.company')?.invalid,
                  }"
                />
              </label>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4">
              <label class="form-group">
                <div class="lum-label">Street 1</div>
                <input
                  type="text"
                  class="lum-input"
                  matInput
                  formControlName="street1"
                  [ngClass]="{
                    error: form?.get('billTo.street1')?.invalid,
                  }"
                />
              </label>
            </div>
            <div class="col-lg-4">
              <label class="form-group">
                <div class="lum-label">Street 2</div>
                <input
                  type="text"
                  class="lum-input"
                  matInput
                  formControlName="street2"
                  [ngClass]="{
                    error: form?.get('billTo.street2')?.invalid,
                  }"
                />
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <label class="form-group">
                <div class="lum-label">City</div>
                <input
                  type="text"
                  class="lum-input"
                  matInput
                  formControlName="city"
                  [ngClass]="{
                    error: form?.get('billTo.city')?.invalid,
                  }"
                />
              </label>
            </div>
            <div class="col-lg-3">
              <label class="form-group">
                <div class="lum-label">State</div>
                <input
                  type="text"
                  class="lum-input"
                  matInput
                  formControlName="state"
                  [ngClass]="{
                    error: form?.get('billTo.state')?.invalid,
                  }"
                />
              </label>
            </div>
            <div class="col-lg-3">
              <label class="form-group">
                <div class="lum-label">ZIP/Postal Code</div>
                <input
                  type="text"
                  class="lum-input"
                  matInput
                  formControlName="postalCode"
                  [ngClass]="{
                    error: form?.get('billTo.postalCode')?.invalid,
                  }"
                />
              </label>
            </div>
            <div class="col-lg-3">
              <label class="form-group">
                <div class="lum-label">Country</div>
                <lum-country-autocomplete
                  [formControl]="form.get('billTo.country')"
                ></lum-country-autocomplete>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <label class="form-group">
                <div class="lum-label">Phone</div>
                <input
                  type="text"
                  class="lum-input"
                  matInput
                  formControlName="phone"
                  [ngClass]="{
                    error: form?.get('billTo.phone')?.invalid,
                  }"
                />
              </label>
            </div>
            <div class="col-lg-3">
              <label class="form-group">
                <div class="lum-label">Email</div>
                <input
                  type="email"
                  class="lum-input"
                  matInput
                  formControlName="email"
                  [ngClass]="{
                    error: form?.get('billTo.email')?.invalid,
                  }"
                />
              </label>
            </div>
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>
      <div class="lum-c-sales-order-form__body-section  row">
        <div class="col-lg-6">
          <label class="form-group">
            <div class="lum-label">Customer-Facing Notes</div>
            <textarea
              rows="5"
              class="lum-textarea"
              placeholder="Add note here..."
              formControlName="customerNotes"
            ></textarea>
          </label>
        </div>
        <div class="col-lg-6">
          <label class="form-group">
            <div class="lum-label">Internal Notes</div>
            <textarea
              rows="5"
              class="lum-textarea"
              placeholder="Add note here..."
              formControlName="internalNotes"
            ></textarea>
          </label>
        </div>
      </div>
      <mat-divider></mat-divider>

      <div class="lum-c-sales-order-form__body-section  row">
        <div class="col-lg-6">
          <label class="form-group">
            <div class="lum-label">Channel</div>
            <lum-channel-control formControlName="channel"></lum-channel-control>
          </label>
        </div>
        <div class="col-lg-6">
          <label class="form-group">
            <div class="lum-label">Status</div>
            <mat-radio-group formControlName="isPosted">
              <mat-radio-button [value]="1">Allocated</mat-radio-button>
              <mat-radio-button [value]="0">Unallocated</mat-radio-button>
            </mat-radio-group>
          </label>
        </div>
      </div>
      <mat-divider></mat-divider>

      <h5 class="text-center text-warning p-3" *ngIf="lineItemsEditDisabled">
        {{ lineItemsEditDisabledReasonText }}
      </h5>

      <div class="lum-c-sales-order-form__body-section">
        <ng-container>
          <div class="flex justify-content-between" *ngIf="!lineItemsEditDisabled">
            <div class="flex gap-2 align-items-center">
              <button
                type="button"
                class="lum-button lum-button--secondary"
                (click)="onOpenSkuDialog()"
              >
                <lum-ui-icon
                  color="#5563d6"
                  width="10"
                  height="10"
                  class="mr-2"
                  icon="add-circle"
                ></lum-ui-icon>
                Add New SKU
              </button>
              <button
                type="button"
                class="lum-button lum-button--secondary"
                (click)="onOpenVariantSkuDialog()"
              >
                <lum-ui-icon
                  color="#5563d6"
                  width="10"
                  height="10"
                  class="mr-2"
                  icon="add-circle"
                ></lum-ui-icon>
                Add New Variant SKU
              </button>
            </div>
            <button
              type="button"
              class="lum-button"
              (click)="onOpenLineItemsDialog()"
            >
              <lum-ui-icon
                width="10"
                height="10"
                class="mr-2"
                icon="add-circle"
              ></lum-ui-icon>
              Add Multiple Line Items
            </button>
          </div>

          <div
            class="flex gap-4 align-items-center justify-space-between"
            *ngIf="!lineItemsEditDisabled"
          >
            <div
              class="scan-mode-container w-99 mt-7"
              *ngIf="!lineItemsEditDisabled"
            >
              <lum-rfq-scan-mode-input
                [loading]="(loading$ | async) || false"
                [rfqs]="rfqs"
                [debounceTime]="0"
                [scanSearchStr]="scanSearchStr"
                (inputChangeEvent)="onSearchRfqs($event, true)"
                (selectSkuEvent)="onSelectSkuFromScanMode($event)"
              ></lum-rfq-scan-mode-input>
            </div>

            <div class="flex align-items-end gap-2 mt-4">
              <button
                type="button"
                class="lum-button lum-button--secondary"
                mat-button
                (click)="onOverrideChange(!isOverride)"
              >
                {{ isOverride ? 'Reset Override' : 'Override' }}
                <lum-ui-icon
                  class="ml-2"
                  icon="{{ isOverride ? 'time-rewind' : 'edit' }}"
                  color="#5563d6"
                >
                </lum-ui-icon>
              </button>
              <div class="w-80">
                <div class="lum-label">Price Level</div>

                <mat-select class="lum-select" formControlName="price_level_id">
                  <mat-option value="">--None--</mat-option>
                  <mat-option
                    *ngFor="let level of pricingLevels$ | async; trackBy: trackById"
                    [value]="level.id"
                    >{{ level.name }}</mat-option
                  >
                </mat-select>
              </div>
              <button
                type="button"
                class="lum-button lum-button--secondary py-4"
                [matMenuTriggerFor]="menu"
                #trigger="matMenuTrigger"
              >
                Columns ({{ displayColumnCount }})
              </button>

              <mat-menu class="lum-mat-menu" #menu="matMenu">
                <ng-container
                  *ngFor="let column of availableColumns; trackBy: trackById"
                >
                  <mat-checkbox
                    #menuItems
                    class="
                      lum-checkbox lum-checkbox--menu
                      d-block py-3 hover:gray-100
                    "
                    name="menu_filters"
                    [checked]="column.visible"
                    (click)="$event.stopPropagation()"
                    (change)="onToggleColumn($event, column)"
                  >
                    {{ column.label }}
                  </mat-checkbox>
                </ng-container>
              </mat-menu>
            </div>
          </div>

          <lum-rfq-table-form-v2
            [form]="form"
            [columns]="displayColumns"
            [lineItemsEditDisabled]="lineItemsEditDisabled"
            [currentSalesOrder]="currentSalesOrder"
            [hasApprovalFlow]="hasApprovalFlow"
            (addRowItems)="handleAddRowItems($event)"
          ></lum-rfq-table-form-v2>
        </ng-container>
        <ng-template #emptySkus>
          <lum-ui-empty-page
            title="There are no SKUs to show"
            message="Please select a company to show available SKUs."
          ></lum-ui-empty-page>
        </ng-template>

        <ng-container>
          <div class="flex flex-column gap-4">
            <div class="flex gap-4 align-items-center justify-content-end">
              <div>
                <b>Order Total: </b>
              </div>
              <div class="w-30 text-end">{{ orderTotal | lumCurrency }}</div>
            </div>
            <div class="flex gap-4 align-items-center justify-content-end">
              <div>
                <b>Shipping: </b>
              </div>
              <div class="w-30">
                <input
                  formControlName="shippingAmount"
                  class="lum-input text-end"
                  type="number"
                  lumDecimalLimit
                  matInput
                  inputmode="numeric"
                  [decimalPlaces]="4"
                />
              </div>
            </div>
            <div
              class="flex gap-4 align-items-center justify-content-end text-warning"
            >
              <div>
                <b>Tax: </b>
              </div>
              <div class="w-30">
                <input
                  formControlName="taxAmount"
                  class="lum-input text-end text-warning"
                  type="number"
                  lumDecimalLimit
                  matInput
                  inputmode="numeric"
                  [decimalPlaces]="4"
                />
              </div>
            </div>
            <div class="flex gap-4 align-items-center justify-content-end">
              <div>
                <b>Sub Total: </b>
              </div>
              <div class="w-30 text-end">
                {{ totalPaid | lumCurrency }}
              </div>
            </div>

            <div class="flex gap-4 align-items-center justify-content-end">
              <div>
                <b>Total Paid: </b>
              </div>
              <div class="w-30 text-end font-weight-bold text-large">
                {{ totalPaid | lumCurrency }}
                <!-- Order order total + shipping + tax -->
                <!-- {{
                  orderTotal +
                    form.get('shippingAmount').value +
                    form.get('taxAmount').value | lumCurrency
                }} -->
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <footer mat-dialog-actions class="lum-c-sales-order-form__foot">
      <lum-ui-button
        mat-dialog-close
        type="secondary"
        [loading]="submitting$ | async"
        >Cancel</lum-ui-button
      >
      <lum-ui-button
        submit
        type="primary"
        [disabled]="form.invalid"
        [loading]="submitting$ | async"
        >Save</lum-ui-button
      >
    </footer>
  </form>
</article>
